import { render } from "./alternative-devices.vue?vue&type=template&id=c84477e0&scoped=true"
import script from "./alternative-devices.vue?vue&type=script&lang=js"
export * from "./alternative-devices.vue?vue&type=script&lang=js"

import "./alternative-devices.vue?vue&type=style&index=0&id=c84477e0&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84477e0"]])

export default __exports__